import React from "react";
import InfiniteTable from "../../../components/InfiniteTable/InfiniteTable";
import { Container, Button, Typography, Stack } from "@mui/material";

import { useHistory } from "react-router-dom";

const columns = [
  { id: "id", editable: "/customer", editablePk: "id", label: "Customer ID" },
  {
    id: "name",
    label: "Customer Location",
  },
];

export const Customers = (props) => {
  const history = useHistory();
  return (
    <>
      <Container>
        <Stack
          direction="row"
          justifyContent="right"
          alignItems="center"
          spacing={2}
          mb={2}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => history.push("/clbulkimport")}
          >
            <Typography variant="subtitle2" className="text-white">
              Bulk Import
            </Typography>
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => history.push("/saletaxrate")}
          >
            <Typography variant="subtitle2" className="text-white">
              Sale Tax Rate
            </Typography>
          </Button>
        </Stack>
        <InfiniteTable
          {...props}
          apiep="companylocations"
          columns={columns}
          data={null}
          dataMapByColumn="id"
          deletable={false}
          editable={true}
          filterable={true}
          label="Customer"
          fetchingModal={null}
        />
      </Container>
    </>
  );
};

export default Customers;
